import { useSelector } from "react-redux";
import { useGetStoreFeaturesQuery } from "../store/api";
import { readEdgeStoreSetup } from "../utils/edgeStoreSetup";
import { normalizeBlockedOrderChannels } from "../utils/orderBlocking";

const normalizePosDineInMode = (value) => {
  if (!value) return null;
  const mode = String(value).trim().toUpperCase();
  if (mode === "TABLE_DINE_IN" || mode === "DINE_IN" || mode === "NONE") {
    return mode;
  }
  return null;
};

const normalizePosEnableTakeaway = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (normalized === "true") return true;
    if (normalized === "false") return false;
  }
  return true;
};

const normalizeBooleanFlag = (value, fallback = false) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (normalized === "true") return true;
    if (normalized === "false") return false;
  }
  return fallback;
};

export const useStoreFeatures = (enabled = true) => {
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const isAuthenticated = Boolean(token && user);
  const activeStoreId =
    user?.storeId ||
    localStorage.getItem("selectedStoreId") ||
    readEdgeStoreSetup()?.storeId ||
    undefined;

  const shouldSkip = !enabled || !isAuthenticated;
  const query = useGetStoreFeaturesQuery(activeStoreId, { skip: shouldSkip });

  const rawFeatures = query.data || null;

  const rawPosDineInMode =
    rawFeatures?.posDineInMode ??
    rawFeatures?.PosDineInMode ??
    rawFeatures?.pos_dine_in_mode ??
    rawFeatures?.posDineinMode ??
    rawFeatures?.PosDineinMode;

  const rawPosEnableTakeaway =
    rawFeatures?.posEnableTakeaway ??
    rawFeatures?.PosEnableTakeaway ??
    rawFeatures?.pos_enable_takeaway;

  const rawIsOrderBlocked =
    rawFeatures?.isOrderBlocked ??
    rawFeatures?.IsOrderBlocked ??
    rawFeatures?.is_order_blocked;

  const rawBlockedOrderChannels =
    rawFeatures?.blockedOrderChannels ??
    rawFeatures?.BlockedOrderChannels ??
    rawFeatures?.blocked_order_channels;

  const features = rawFeatures
    ? {
        ...rawFeatures,
        posDineInMode: normalizePosDineInMode(rawPosDineInMode),
        posEnableTakeaway: normalizePosEnableTakeaway(rawPosEnableTakeaway),
        isOrderBlocked: normalizeBooleanFlag(rawIsOrderBlocked, false),
        blockedOrderChannels: normalizeBlockedOrderChannels(
          rawBlockedOrderChannels,
        ),
      }
    : null;
  const hasFeatures = Boolean(query.data);

  return {
    ...query,
    features,
    hasFeatures,
    isAuthenticated,
    activeStoreId,
  };
};
